import React, { useState, useEffect } from 'react';
import delay from 'lodash/delay';
import isEmpty from 'lodash/isEmpty';
import { useSelector, useDispatch } from 'react-redux';
import { Input, INPUT_STATE_ERROR } from '@yme/atoms/input';
import { MobileDropdownSlider, ANIMATION_TRANSITION_DURATION, } from '@yme/atoms/mobile-dropdown-slider';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { MD_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { sendCartByEmail } from '@yme/common/redux/cart/services';
import { getCheckoutLabels, getDealersToolsLabels, getPrivacyPolicyPageLink, } from '@yme/components/CheckoutForm/redux/selectors';
import { getUserAccountDealerId } from '@yme/components/Header/ProfileMenu/redux/selectors';
import { setValidateConfig, validateField } from '@yme/forms/actions';
import { getValidationState } from '@yme/forms/selectors';
import { useWindowSize } from '@yme/hooks/index';
import { setIsModalHide } from '@yme/modals/actions';
import { getCommonLabels, getRTL } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { DigitalDataMutation, setDigitalData } from '@yme/utils/common';
import { BLANK } from '@yme/utils/constants';
import { SHARE_CART_BY_EMAIL_FORM, validationConfig, NAME_MAX_LENGTH, EMAIL_MAX_LENGTH, } from './constants';
import { getEmailErrorText } from './helpers';
import { DividerStyled, LinkStyled } from './styled';
export function ShareCartByEmailModal() {
    const [isOpenMobileSlider, setIsOpenMobileSlider] = useState(false);
    const isRightToLeft = useSelector(getRTL);
    const commonLabels = useSelector(getCommonLabels);
    const { checkout_personalDetailsRequiredField_error: fieldRequired, checkout_incorrectEmail_error: invalidEmail, } = useSelector(getCheckoutLabels);
    const dealerToolsLabels = useSelector(getDealersToolsLabels);
    const privacyPolicyPageLink = useSelector(getPrivacyPolicyPageLink);
    const validationState = useSelector(getValidationState)[SHARE_CART_BY_EMAIL_FORM];
    const userAccountDealerId = useSelector(getUserAccountDealerId);
    const dispatch = useDispatch();
    const { isInfiniteDesktopView } = useWindowSize();
    useEffect(() => {
        if (!userAccountDealerId) {
            return;
        }
        setDigitalData(DigitalDataMutation.CART_SHARE_EMAIL, {
            dealerId: userAccountDealerId,
        });
    }, [userAccountDealerId]);
    useEffect(() => {
        delay(() => setIsOpenMobileSlider(true), ANIMATION_TRANSITION_DURATION);
    }, []);
    useEffect(() => {
        dispatch(setValidateConfig(validationConfig));
    }, [dispatch]);
    const onFieldHandler = (value, field, isTouched) => {
        dispatch(validateField({
            form: SHARE_CART_BY_EMAIL_FORM,
            field,
            value,
            validationConfig,
            cb: null,
            isTouched,
        }));
    };
    const handleHideModal = () => {
        if (isInfiniteDesktopView) {
            dispatch(setIsModalHide());
        }
        else {
            setIsOpenMobileSlider(false);
            delay(() => dispatch(setIsModalHide()), ANIMATION_TRANSITION_DURATION);
        }
    };
    const onSubmitForm = (event) => {
        event.preventDefault();
        dispatch(setIsModalHide());
        dispatch(sendCartByEmail(validationState.name.value, validationState.email.value));
    };
    const modalFooter = (React.createElement(ModalWindowFooter, { isSubmitButton: true, isCancelButton: true, submitButtonLabel: commonLabels.common_confirm_button, cancelButtonLabel: commonLabels.common_cancel_button, submitButtonType: "submit", submittingForm: SHARE_CART_BY_EMAIL_FORM, isSubmitButtonFullWidth: !isInfiniteDesktopView, isSubmitButtonDisabled: !isEmpty(validationState?.email?.errors), onHide: handleHideModal }));
    const modalContent = (React.createElement("form", { onSubmit: onSubmitForm, id: SHARE_CART_BY_EMAIL_FORM },
        React.createElement(FlexWrapper, { flexDirection: "column", gap: INDENT.sm },
            React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, dealerToolsLabels.checkout_dealersToolsShareViaEmailPopUp_description),
            React.createElement(Input, { id: "name", name: "name", label: dealerToolsLabels.checkout_dealersToolsShareViaEmailPopUpNameField_label, placeholder: dealerToolsLabels.checkout_dealersToolsShareViaEmailPopUpNameField_placeholder, changeHandler: (value) => onFieldHandler(value, 'name'), value: validationState?.name?.value, maxLength: NAME_MAX_LENGTH, isRightToLeft: isRightToLeft }),
            React.createElement(Input, { id: "email", name: "email", label: dealerToolsLabels.checkout_dealersToolsShareViaEmailPopUpEmailField_label, placeholder: dealerToolsLabels.checkout_dealersToolsShareViaEmailPopUpEmailField_placeholder, changeHandler: (value) => onFieldHandler(value, 'email'), blurHandler: () => onFieldHandler(validationState?.email?.value, 'email', true), value: validationState?.email?.value, isRightToLeft: isRightToLeft, state: validationState?.email?.isTouched && !isEmpty(validationState?.email?.errors)
                    ? INPUT_STATE_ERROR
                    : undefined, infoText: validationState?.email
                    ? getEmailErrorText(validationState?.email, fieldRequired, invalidEmail)
                    : undefined, maxLength: EMAIL_MAX_LENGTH, isRequired: true }),
            React.createElement(DividerStyled, null),
            React.createElement(RegularTextLevel3, { color: colorCoreBlack300 },
                `${dealerToolsLabels.checkout_dealersToolsShareViaEmailPopUpTerms_description} `,
                React.createElement(LinkStyled, { onClick: handleHideModal, to: privacyPolicyPageLink, target: BLANK }, dealerToolsLabels.common_privacyPolicy_link)))));
    if (isInfiniteDesktopView) {
        return (React.createElement(StaticModalWindow, { title: dealerToolsLabels.checkout_dealersToolsShareViaEmailPopUp_header, staticModalSize: MD_MODAL, minHeight: "auto", isRightToLeft: isRightToLeft, footerComponent: modalFooter, onHide: handleHideModal }, modalContent));
    }
    return (React.createElement(MobileDropdownSlider, { title: dealerToolsLabels.checkout_dealersToolsShareViaEmailPopUp_header, isActive: isOpenMobileSlider, handleActiveMobileSlider: handleHideModal, footerComponent: modalFooter, isRightToLeft: isRightToLeft }, modalContent));
}
